import React, { useState } from "react";
import {
  getPortfoExcelFile,
  portfoForceUpdate,
} from "../../Requests/portfolioRequests";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { packetErrorHandler } from "../../Utils/requestUtils";
import PortfoAggregateWrapper from "./PortfoAggregateWrapper";
import TabBox from "../../Components/Tabbox/TabBox";
import InsTableWrapper from "./InsTableWrapper";
import Button from "../../Components/Button";
import FileDownloader from "../../Components/FileDownloader";
import { toast } from "react-toastify";

enum ActiveTab {
  Hesabdari,
  Protfo,
}

const Portfolio = () => {
  const [activeTab, setActiveTab] = useState(ActiveTab.Hesabdari);
  const [loading, setLoading] = React.useState(false);
  const [aggregateFlag, setAggregateFlag] = useState(false);
  const [portfoFlag, setPortfoFlag] = useState(false);

  const forceUpdateHandler = () => {
    if (loading) return;
    setLoading(true);
    portfoForceUpdate()
      .then((res) => {
        if (!res.data) toast.error(res.msg);
        else {
          toast.success(res.msg);
          setAggregateFlag(true);
          setPortfoFlag(true);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getUI = () => {
    switch (activeTab) {
      case ActiveTab.Hesabdari:
        return (
          <PortfoAggregateWrapper
            aggregateFlag={aggregateFlag}
            portfoFlag={portfoFlag}
            setAggregateFlag={setAggregateFlag}
            setPortfoFlag={setPortfoFlag}
          />
        );

      case ActiveTab.Protfo:
        return <InsTableWrapper />;

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <div className="flex flex-row justify-start items-center gap-5 w-full">
        <div className="w-min">
          <TabBox
            activeTab={activeTab}
            children={[
              { index: ActiveTab.Hesabdari, title: "حسابداری" },
              { index: ActiveTab.Protfo, title: "پورتفو" },
            ]}
            onChange={(_, i) => setActiveTab(i)}
          />
        </div>
        {loading ? <FullScreenLoading /> : null}
        <FileDownloader getFile={getPortfoExcelFile} />
        <div className="w-min">
          <Button
            onClick={forceUpdateHandler}
            text="دریافت اطلاعات"
            variant="contained"
          />
        </div>
      </div>
      {getUI()}
    </div>
  );
};

export default Portfolio;
